import React from "react";
import { Link } from "@quintype/components";

import './app-logo.module.css';

function AppLogo(props) {
  const linkContent = props.publisherTheme.logo ?
    <img styleName="logo" src={props.publisherTheme.logo} alt={props.title} /> : props.publisherName;

  return (
  <div styleName="wrapper">
    <div styleName="burger-icon" onClick={props.openSidemenu}>
     <svg width="32" height="32" viewBox="0 0 18 12" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd"><path d="M-3-6h24v24H-3z"/><path d="M0 12h18v-2H0v2zm0-5h18V5H0v2zm0-7v2h18V0H0z" fill="currentColor"/></g></svg>
    </div>
    <div styleName="logo-wrapper">
      <Link href="/">{linkContent}</Link>
    </div>
  </div>
  );
}

export { AppLogo };
